// extracted by mini-css-extract-plugin
export default {"subheader":"KiDna1","desktop":"ZpZC5U","mobile":"rd8db4"};